import { Component, OnInit, Input } from '@angular/core';
import { ServiceType, UserService } from '@sabstravtech/obtservices/angular';
import { faMagnifyingGlass } from '@fortawesome/pro-regular-svg-icons';

@Component({
  selector: 'app-no-results',
  templateUrl: './no-results.component.html',
  styleUrls: ['./no-results.component.scss'],
  standalone: false
})
export class NoResultsComponent implements OnInit {
  number = '';
  icon = faMagnifyingGlass;

  constructor(public userService: UserService) {
    const userOffice = this.userService.fullUserDetails.allDetails.value.office;
    this.number = `+${userOffice.supportPhoneNumber?.countryCode} ${userOffice.supportPhoneNumber?.areaCode} ${userOffice.supportPhoneNumber?.number}`;
  }

  ngOnInit(): void {}
}
